<template>
  <div class="local-camera">
    <!-- <h4 class="camera-title">Your Camera</h4> -->

    <div class="camera-container">
      <div class="camera-placeholder">
        <!-- <i class="fas fa-video camera-icon"></i> -->
        <!-- <p class="camera-text">Camera Feed</p> -->
        <!-- <p class="camera-subtext">(You)</p> -->
        <!-- <video autoplay playsinline ref="vp" /> -->
        <slot name="video" />
      </div>
      <div class="camera-controls">
        <button
          class="camera-btn"
          :class="{ active: cameraEnabled }"
          @click="toggleCamera"
        >
          <i :class="cameraEnabled ? 'fas fa-video' : 'fas fa-video-slash'"></i>
        </button>

        <button class="camera-btn" :class="{ active: micEnabled }" @click="toggleMic">
          <i :class="micEnabled ? 'fas fa-microphone' : 'fas fa-microphone-slash'"></i>
        </button>

        <button class="camera-btn settings-btn" @click="openSettings">
          <i class="fas fa-cog"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LocalCamera",
  data() {
    return {
      cameraEnabled: false,
      micEnabled: false,
    };
  },
  mounted() {
    if (this.localStream) {
      this.$refs.vp.srcObject = this.stream;
    }
  },
  methods: {
    toggleCamera() {
      this.cameraEnabled = !this.cameraEnabled;
      this.$emit("camera-toggle", this.cameraEnabled);
      // Future: Implement actual camera toggle
    },

    toggleMic() {
      this.micEnabled = !this.micEnabled;
      this.$emit("mic-toggle", this.micEnabled);
      // Future: Implement actual microphone toggle
    },

    openSettings() {
      // Future: Open camera/audio settings modal
      console.log("Opening camera settings...");
    },
  },
};
</script>

<style scoped>
.local-camera {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.camera-title {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  text-align: center;
}

.camera-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.camera-placeholder {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #000;
  border-radius: 8px;
  color: white;
  min-height: 120px;
  margin-bottom: 12px;
}

.camera-icon {
  font-size: 32px;
  margin-bottom: 8px;
  opacity: 0.7;
}

.camera-text {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
}

.camera-subtext {
  margin: 4px 0 0 0;
  font-size: 12px;
  opacity: 0.7;
}

.camera-controls {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.camera-btn {
  width: 36px;
  height: 36px;
  border: 1px solid #ddd;
  border-radius: 50%;
  background-color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.camera-btn:hover {
  background-color: #f5f5f5;
}

.camera-btn.active {
  background-color: #28a745;
  border-color: #28a745;
  color: white;
}

.camera-btn i {
  font-size: 14px;
}

.settings-btn {
  border-color: #6c757d;
  color: #6c757d;
}

.settings-btn:hover {
  background-color: #6c757d;
  color: white;
}
</style>
